import { useRef, useState, useEffect } from "react";
import useAuth from "../../hooks/useAuth";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "../../api/axios";

const LOGIN_URL = "/auth";

const Login = () => {
  const { setAuth } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState("");
  const [pwd, setPwd] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [persist, setPersist] = useState(
    localStorage.getItem("persist") === "true"
  );

  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg("");
  }, [user, pwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ user, pwd }),
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      const accessToken = response?.data?.accessToken;
      const roles = response?.data?.roles;
      const status = response?.data?.status;

      setAuth({ user, pwd, roles, accessToken });
      setUser("");
      setPwd("");
      setErrMsg("");

      localStorage.setItem("userstatus", status);

      if (roles?.find((role) => role === 1984)) {
        navigate("/manager");
      } else if (roles?.find((role) => role === 5150)) {
        navigate("/admin");
      } else {
        navigate(from);
      }
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 400) {
        setErrMsg("Missing Username or Password");
      } else if (err.response?.status === 401) {
        setErrMsg("Invalid Credentials");
      } else {
        setErrMsg("Login Failed");
      }
      errRef.current.focus();
    }
  };

  const togglePersist = () => {
    setPersist((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem("persist", persist);
  }, [persist]);

  return (
    <section className="lg:w-3/5 fade-in">
      <p
        ref={errRef}
        className={errMsg ? "errmsg" : "offscreen"}
        aria-live="assertive"
      >
        {errMsg}
      </p>

      <h1 className="text-4xl font-bold mb-2 text-center">Welcome Back</h1>
      <p className="text-center text-base mb-8" style={{ color: 'var(--text-muted)' }}>
        Sign in to access your psychometric assessments
      </p>

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="username">Email Address</label>
          <input
            type="text"
            id="username"
            ref={userRef}
            autoComplete="off"
            onChange={(e) => setUser(e.target.value)}
            value={user}
            required
            placeholder="Enter your email"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <div style={{ position: 'relative' }}>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              onChange={(e) => setPwd(e.target.value)}
              value={pwd}
              required
              placeholder="Enter your password"
              style={{ paddingRight: '3rem' }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '1rem',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                color: 'var(--text-muted)',
                cursor: 'pointer',
                padding: '0.25rem',
                fontSize: '0.875rem',
                textTransform: 'none',
                letterSpacing: 'normal'
              }}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </button>
          </div>
        </div>

        <div className="persistCheck">
          <input
            type="checkbox"
            id="persist"
            checked={persist}
            onChange={togglePersist}
          />
          <label htmlFor="persist">Remember me on this device</label>
        </div>

        <button className="btn-primary" type="submit">
          Sign In
        </button>
      </form>

      <div style={{ marginTop: '1.5rem', textAlign: 'center' }}>
        <Link to="/resetpassword">
          <p style={{ fontSize: '0.875rem', color: 'var(--accent-cyan)' }}>
            Forgot Password?
          </p>
        </Link>
      </div>
    </section>
  );
};

export default Login;
